import { createSelector } from 'reselect'

const selectCountriesToValues = createSelector(
  state => state.countries.countriesList,
  countriesList =>
    countriesList.reduce((acc, country) => {
      if (
        [
          'United States',
          'Australia',
          'United Kingdom',
          'France',
          'Canada',
          'Belgium',
          // 'New Zealand',
          'Netherlands',
          'Germany',
          'Spain',
          'Switzerland',
        ].includes(country.name)
      ) {
        acc.push({ value: country.id, name: country.name, code: country.code })
      }
      return acc
    }, []),
)

export { selectCountriesToValues }
